import { getPayloadObject, getTelemetryAttributes } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { IDropdownItemProps, IDropdownProps, IDropdownOnSelectionChangeNotification } from '@msdyn365-commerce-modules/buybox';
import classnames from 'classnames';

export type IDropdownExtItemProps = IDropdownItemProps & { isValid?: boolean };
export type IDropdownExtOnSelectionChangeNotification = IDropdownOnSelectionChangeNotification & { isValid?: boolean };

export type IDropdownExtProps = Omit<IDropdownProps, 'dropdownList' | 'onChange'> & {
    defaultToUniqueOption?: boolean;
    dropdownList: IDropdownExtItemProps[];
    onChange?(notification: IDropdownExtOnSelectionChangeNotification): Promise<void>;
};

const RadioButtonList = (props: IDropdownExtProps) => {
    const { telemetryContent, dropdownList, dropdownName, onChange, dropdownId, defaultToUniqueOption } = props;
    const [selectedId, setSelectedId] = React.useState('');

    const payLoad = React.useMemo(() => {
        return getPayloadObject('click', telemetryContent!, dropdownName);
    }, [telemetryContent, dropdownName]);

    const handleOnChange = React.useCallback(
        async (item: IDropdownExtItemProps) => {
            if (item.id !== selectedId) {
                setSelectedId(item.id);
                if (onChange) {
                    await onChange({
                        dropdownId: dropdownId,
                        isValid: item.isValid,
                        selectId: item.id,
                        selectedValue: item.value
                    });
                }
            }
        },
        [onChange, dropdownId, setSelectedId]
    );

    let selectedItem = dropdownList.find(item => item.isDefault);

    if (!selectedItem && defaultToUniqueOption) {
        selectedItem = dropdownList.find(i => i.isValid);

        process.env.NODE_ENV === 'development' &&
            console.log(
                'buybox-product-configure',
                'auto select',
                JSON.parse(JSON.stringify(dropdownList)),
                JSON.parse(JSON.stringify(selectedItem ?? 'not found'))
            );
    }

    React.useEffect(() => {
        if (selectedItem) {
            setTimeout(() => {
                if (selectedItem) {
                    void handleOnChange({
                        id: selectedItem.id,
                        value: selectedItem.value
                    });
                }
            }, 250);
        }
    }, [selectedItem]);

    if (dropdownList.length === 0 && console?.warn) {
        console.warn(`No option for ${dropdownName}`);
    }

    const attribute = getTelemetryAttributes(telemetryContent!, payLoad);

    return (
        <div className='hei-radio-button-list' {...attribute} aria-label={dropdownName}>
            {dropdownList.map(item => (
                <label
                    key={item.id}
                    className={classnames({
                        'hei-radio-button-list__item_selected': item.id === selectedId,
                        'hei-radio-button-list__item_invalid': !item.isValid,
                        'hei-radio-button-list__item_disabled': item.isDisabled
                    })}
                >
                    <input
                        type='radio'
                        name={`hei-radio-${dropdownName}`}
                        value={item.id}
                        checked={item.id === selectedId}
                        onChange={evt => handleOnChange(item)}
                    />
                    {item.value}
                </label>
            ))}
        </div>
    );
};

export { RadioButtonList };
